export default "__VITE_ASSET__yLp_mH6d__"